import { Injectable } from '@angular/core'
import { TaskStatus } from '@awork/features/task/models/task-status.model'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'

@Injectable({ providedIn: 'root' })
export class TaskStatusStore extends EntitySignalStore<TaskStatus> {
  constructor() {
    super({
      name: 'taskStatus',
      entityConstructor: taskStatus => new TaskStatus(taskStatus),
      nullableProps: ['order', 'projectId', 'projectTemplateId', 'workflowId']
    })
  }
}
